var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"custom-marker-wrapper",class:_vm.open ? 'open' : 'closed'},[_c('img',{staticClass:"custom-marker",attrs:{"src":_vm.getImageSrc},on:{"click":_vm.toggle}})])
}
var staticRenderFns = []

export { render, staticRenderFns }